function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireac40"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireac40"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("h560Q", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("4WbAZ"), import.meta.url).toString();

});

parcelRequire.register("e5r2s", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("9bpf5"), import.meta.url).toString();

});

parcelRequire.register("jgoh3", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("5r4Wf"), import.meta.url).toString();

});

var $d9908281afd6153c$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"lnBkO":"index.c386b48d.js","4WbAZ":"menuIcon.81807499.png","9bpf5":"icons8-x-48.9cf1b915.png","5r4Wf":"up.6fbf7732.png"}'));

function $2e0f731592f515ed$export$98a4d7f3a5ab0973() {
    const menu = document.querySelector(".menu");
    menu.innerHTML = $2e0f731592f515ed$var$renderNav();
    const priNav = document.querySelector("#primaryNav");
    const navEl = document.querySelector("nav");
    const x = document.querySelector("#hamburgerBtn");
    x.style.backgroundColor = "transparent";
    x.style.border = "none";
    x.style.cursor = "pointer";
    x.addEventListener("mouseover", ()=>{
        x.style.opacity = ".7";
        setTimeout(()=>{
            x.style.opacity = "1";
        }, 1000);
    });
    x.addEventListener("click", ()=>{
        priNav.classList.toggle("open");
        x.classList.toggle("open");
        navEl.classList.toggle("open");
    });
}


function $2e0f731592f515ed$var$renderNav() {
    return `<nav>
    <button id="hamburgerBtn">
        <span><img src="${(parcelRequire("h560Q"))}" alt="hamburger menu icon"></span>
        <span><img src="${(parcelRequire("e5r2s"))}" alt="close menu icon"></span>
    </button>
    <ul id="primaryNav">
        <li><a href="/user/index.html">Profile</a></li>
        <li><a href="/planning/index.html">Planner</a></li>
        <li><a href="/watch-party/index.html">Watch Party</a></li>
    </ul>
  </nav> `;
}


// creates the search box
function $ef9ead9c61ffd087$export$9eb1cf087813c7e() {
    const searchInput = document.createElement("input");
    searchInput.setAttribute("type", "text");
    searchInput.setAttribute("id", "searchInput");
    searchInput.setAttribute("placeholder", "Enter your search...");
    searchInput.classList.add("search-input");
    // create the search button element
    const searchButton = document.createElement("button");
    searchButton.setAttribute("id", "searchButton");
    searchButton.textContent = "\uD83D\uDD0D";
    searchButton.classList.add("search-button");
    const searchBox = document.createElement("div");
    searchBox.classList.add("search-box");
    searchBox.style.display = "inline-flex";
    searchBox.appendChild(searchInput);
    searchBox.appendChild(searchButton);
    // append the search box and button to the menu div
    const menuDiv = document.querySelector(".search-movie");
    menuDiv.prepend(searchBox);
}
function $ef9ead9c61ffd087$export$4b597114ade5582d(searchTerm) {
    localStorage.setItem("searchTerm", searchTerm);
    // Create URL parameters and set the search term
    const urlParams = new URLSearchParams();
    urlParams.set("search", searchTerm);
    // Get the root path of the website so we can uses the search box everywhere
    const rootPath = window.location.origin;
    // create the new URL with the search term as a parameter
    const newUrl = `${rootPath}/results/index.html?${urlParams.toString()}`;
    // redirect the page to the new URL
    window.location.href = newUrl;
}


// retrieve data from localstorage
function $2a0a9d2c002157bd$export$d3720feff416e85b(key) {
    return JSON.parse(localStorage.getItem(key));
}
function $2a0a9d2c002157bd$export$1f73f60bdb811cb1(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}
function $2a0a9d2c002157bd$export$7f4d634b10993eb6(param = "", mainEl = document.querySelector("main")) {
    const breadcrumbNav = document.createElement("div");
    breadcrumbNav.classList.add("breadcrumb-navigation");
    const breadcrumbList = document.createElement("ul");
    breadcrumbList.classList.add("breadcrumb-list");
    // create the home link and add it to the breadcrumb list
    const homeLink = $2a0a9d2c002157bd$var$createBreadcrumbLink("Home", "/index.html");
    breadcrumbList.appendChild(homeLink);
    // get the current path of the page and split it into segments
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/").filter((segment)=>segment !== "");
    // variables to keep track of the path and previous segment
    let path = "/";
    let previousSegment = "";
    // iterate through the path segments
    for(let i = 0; i < pathSegments.length; i++){
        // append the current segment to the path
        path += pathSegments[i];
        // Check if the current segment is different from the previous segment
        if (pathSegments[i] !== "index.html" && pathSegments[i] !== previousSegment) {
            // create the segment link and add it to the breadcrumb list
            const segmentLink = $2a0a9d2c002157bd$var$createBreadcrumbLink(pathSegments[i], path);
            breadcrumbList.appendChild(segmentLink);
            // check if it is not the last segment to add a slash
            if (i !== pathSegments.length - 1) {
                const slash = document.createElement("span");
                slash.classList.add("breadcrumb-slash");
                slash.textContent = "/";
                breadcrumbList.appendChild(slash);
            }
        }
        // Update the previous segment
        previousSegment = pathSegments[i];
    }
    // Check if a parameter is provided and add it to the breadcrumb list
    if (param !== "") {
        const paramLink = $2a0a9d2c002157bd$var$createBreadcrumbLink(param);
        breadcrumbList.appendChild(paramLink);
    }
    // Append the breadcrumb list to the breadcrumb navigation container
    breadcrumbNav.appendChild(breadcrumbList);
    // Insert the breadcrumb navigation container at the beginning of the main element
    mainEl.insertAdjacentElement("afterbegin", breadcrumbNav);
}
// Function to create a breadcrumb link
function $2a0a9d2c002157bd$var$createBreadcrumbLink(text, href = "") {
    // only for the results page so it would not redirect towards an empty page
    if (text === "results") {
        const searchTerm = localStorage.getItem("searchTerm"); // retrieve the search term from local storage
        const searchParam = encodeURIComponent(searchTerm); // encode the search term for URL
        href = `/results/index.html?search=${searchParam}`;
    }
    // create the link element
    const link = document.createElement("a");
    link.href = href;
    link.textContent = text;
    // Create the list item element and add the link to it
    const listItem = document.createElement("li");
    listItem.classList.add("breadcrumb-item");
    listItem.appendChild(link);
    if (text === "Home") {
        // Create and append the slash element after the home link
        const slash = document.createElement("span");
        slash.classList.add("breadcrumb-home");
        slash.textContent = "/";
        listItem.appendChild(slash);
    }
    return listItem;
}
function $2a0a9d2c002157bd$export$ecf541e09a511845(param) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const url = urlParams.get(param);
    return url;
}
async function $2a0a9d2c002157bd$export$7a171f172be0782e(url) {
    const response = await fetch(url);
    const data = await response.json();
    console.log(data);
    return data;
}
function $2a0a9d2c002157bd$export$73bcfb39fabe8205(movie, list) {
    const favList = $2a0a9d2c002157bd$export$d3720feff416e85b(list) || [];
    const index = favList.findIndex((item)=>item.Title === movie.Title);
    if (index === -1) {
        favList.push({
            ...movie,
            poster: movie.Poster,
            title: movie.Title
        });
        $2a0a9d2c002157bd$export$1f73f60bdb811cb1(list, favList);
    }
}
function $2a0a9d2c002157bd$export$b61b48db6d2fd5e7(movie) {
    const comment = document.querySelector("#comment").value;
    const username = document.querySelector("#username").value;
    const mTitle = document.querySelector("#mTitle").value;
    const inputDate = document.querySelector("#formDateSend");
    const notice = document.querySelector(".notice");
    let d = new Date();
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    let date = `${months[d.getMonth()]}, ${d.getDate()} ${d.getFullYear()}`;
    let reviewLst = $2a0a9d2c002157bd$export$d3720feff416e85b("reviews") || [];
    if (!username == "" || !comment == "") {
        reviewLst.push({
            comment: comment,
            name: username,
            movie: mTitle,
            date: inputDate.value = date
        });
        $2a0a9d2c002157bd$export$1f73f60bdb811cb1("reviews", reviewLst);
        if (movie.Title) notice.innerHTML = `<p>Your Review for ${movie.Title} was added</p>`;
        else notice.innerHTML = `<p>Your Review for ${movie} was added</p>`;
        setTimeout(function() {
            window.location.reload();
        }, 4000);
    } else {
        console.log("comment not addewd");
        notice.innerHTML = `<p>There was an error and the comment was not added</p>`;
    }
}
function $2a0a9d2c002157bd$export$a339b9dfcf153d0e(img, movie, src) {
    const favList = $2a0a9d2c002157bd$export$d3720feff416e85b("fav-list") || [];
    img.src = src;
    $2a0a9d2c002157bd$export$1f73f60bdb811cb1("toggle-icon", true);
}

function $2a0a9d2c002157bd$export$538bbf850262f928() {
    const scrollBtn = document.createElement("img");
    scrollBtn.src = (parcelRequire("jgoh3"));
    scrollBtn.setAttribute("id", "scroll-Btn");
    document.body.appendChild(scrollBtn);
    document.addEventListener("scroll", ()=>{
        scrollBtn.style.display = window.scrollY > 100 ? "block" : "none";
    });
    scrollBtn.addEventListener("click", ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}


document.addEventListener("DOMContentLoaded", ()=>{
    const searchButton = document.querySelector("#searchButton");
    const searchInput = document.querySelector("#searchInput");
    //  event listener for when the research is sent
    searchButton.addEventListener("click", ()=>{
        const searchTerm = searchInput.value; // getting the value from the search input
        (0, $ef9ead9c61ffd087$export$4b597114ade5582d)(searchTerm); // redirecting to the search results page with the search term
    });
    const loginForm = document.getElementById("login-user");
    const redirectParam = "src/user/index.html";
    loginForm.addEventListener("submit", (e)=>{
        e.preventDefault();
        window.location = "/user/index.html";
    });
});
(0, $2a0a9d2c002157bd$export$7f4d634b10993eb6)();
(0, $ef9ead9c61ffd087$export$9eb1cf087813c7e)();
(0, $2a0a9d2c002157bd$export$538bbf850262f928)();
(0, $2e0f731592f515ed$export$98a4d7f3a5ab0973)();


//# sourceMappingURL=index.c386b48d.js.map
